<template>
    <div class="feedback">
        <slot></slot>
        <b-form-invalid-feedback :force-show="errors !== null" style="margin:0">
            <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
        </b-form-invalid-feedback>
    </div>
</template>

<style scoped>
ul {
    list-style: none;
    padding: 0;
    margin: 0
}

.feedback {
    margin: 0;
    padding: 0;
    margin-bottom: 1rem;
}

.form-group {
    margin: 0 !important;
}
</style>

<script>
export default {
    props: {
        errors: {
            type: Array,
            default: null
        }
    }
}
</script>
